module.exports = __webpack_public_path__ + "static/img/117_TO8_1649.0494c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/117_TO8_1649.jpg
// module id = K3Tv
// module chunks = 0